import * as React from 'react'

import { IconComponent } from '../../../../types'

export const AvalancheNaked: IconComponent = (props) => (
  <svg viewBox="0 0 128 128" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#a)" fillRule="evenodd" clipRule="evenodd" fill="#E84142">
      <path d="M100.998 93.978a3.169 3.169 0 0 1-1.433 2.5c-.788.522-2.111.522-4.741.522h-17.83c-2.63 0-3.953 0-4.725-.506a3.21 3.21 0 0 1-1.433-2.5c-.047-.927.604-2.056 1.907-4.316l.03-.053 8.9-15.353c1.307-2.263 1.968-3.387 2.787-3.815a3.123 3.123 0 0 1 2.85 0c.814.417 1.448 1.494 2.703 3.626l.102.173 8.93 15.353c.044.076.086.15.13.223 1.237 2.147 1.869 3.242 1.823 4.146ZM76.878 55.83c-.315 1.33-1.024 2.595-2.458 5.112L58.282 89.608l-.041.074c-1.42 2.5-2.141 3.766-3.14 4.722a9.385 9.385 0 0 1-3.828 2.232c-1.306.364-2.772.364-5.7.364H33.128c-2.614 0-3.905 0-4.693-.506a3.182 3.182 0 0 1-1.434-2.486c-.047-.933.599-2.073 1.89-4.352l30.723-54.419c1.307-2.31 1.969-3.466 2.804-3.893a3.156 3.156 0 0 1 2.867 0c.835.427 1.496 1.583 2.803 3.893l6.316 11.08.032.056c1.412 2.48 2.128 3.737 2.441 5.056a9.461 9.461 0 0 1 0 4.4Z" />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" transform="translate(27 31)" d="M0 0h74v66H0z" />
      </clipPath>
    </defs>
  </svg>
)
